import React, { useState, useEffect } from "react";
import ApiService from "../../../services/api.service";
import Helper from "../../../common/helper";
import Spinner from "../../../common/spinner";
import ErrorBoundary from "../../errors/ErrorBoundary";

export default function AsiaPayDirectLink({
  member,
  transactionId,
  locationData,
  pMethod,
  goNextStep,
}) {
  const [iframeSource, setSrc] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (
      locationData.PaymentMethod.AsiaPay &&
      locationData.PaymentMethod.AsiaPay.Enabled
    ) {
      let params = {
        orderRef: transactionId,
        PaymentSName: locationData.PaymentMethod.AsiaPay.PaymentSName,
        payMethod: pMethod,
      };
      triggerAsiaPayDirectLinkPromise(params);
    }
  }, []);

  async function triggerAsiaPayDirectLinkPromise(params) {
    let asiapayClientResult = await ApiService.asiaPayDirectLink(params);

    try {
      setSrc(asiapayClientResult.dplResponse.dplUrl);
      //setIsLoaded(true);
    } catch (err) {
      setError(err);
      setIsLoaded(true);
    }
  }

  const iframeLoaded = () => {
    setIsLoaded(true);
  };

  window.addEventListener(
    "message",
    function (event) {
      if (event.data.event_id == "ASIAPAY_SUCCESS_DATA") {
        let data = Helper.urlParametersToJson(event.data.data.orderRef);
        goNextStep(transactionId, null, "AsiaPay Direct Link");
      } else if (event.data.event_id == "ASIAPAY_FAIL_DATA") {
        console.error("message :: ASIAPAY_FAIL_DATA :: event data", event);
        let params = {
          orderRef: transactionId,
          PaymentSName: locationData.PaymentMethod.AsiaPay.PaymentSName,
          payMethod: pMethod,
        };
        triggerAsiaPayDirectLinkPromise(params);
        setIsLoaded(false);
      }
    },
    false
  );

  if (error) {
    // return <div>Error: {error}</div>;
    throw new Error(error);
  } /*else if (!isLoaded) {
    return <div>Loading...</div>;
  } */ else {
    return (
      <ErrorBoundary>
        <div>
          {!isLoaded ? (
            <div class="flex content-center justify-center">
              <Spinner />
            </div>
          ) : null}
          <div>
            <iframe
              id="directPaymentClient"
              onLoad={iframeLoaded}
              src={iframeSource}
              height="750"
              width="100%"
              // scrolling="no"
              frameborder="0"
            ></iframe>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}
